import GlideAutoCarousel from "design-system/resources/assets/js/glideAutoSlide";

export default function getIdCarouselForGlideSlide() {
  const glideSelectors = document.querySelectorAll('.glide');

  glideSelectors && glideSelectors.forEach((e)=>{
    e.style.visibility = "visible";
    var currId = e.getAttribute('id');
    if(currId) {
      GlideAutoCarousel("#" + currId);
    }
  })
}